module.exports = __webpack_public_path__ + "static/nxrt-mainpage-209a7a418cdfcc159caad4ded3df5104.jpg";